import { NodeTypes } from '../variables'
import ClientsTable from './ClientsTable'
import ClientView from './Client'
import Account from './Account';
import * as React from 'react';
import context from './context/shared';
import { observer } from 'mobx-react-lite';

const AdministrationTable = observer(() => {
    const { currentNode } = context;
    return (
        currentNode ?
            currentNode.type == NodeTypes.account ?
                <Account /> :
                currentNode.type == NodeTypes.root ? <ClientsTable /> :
                    <ClientView /> :
                    <></>
    );    
})

export default AdministrationTable;